/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import 'slick-carousel';

import jQuery from 'jquery';
let $ = window.$ = window.jQuery = jQuery;

export default class extends Component {
    update(props) {
        let newState = {
            region: props.region,
            tipos: props.tipos,
            elegido: props.elegido,
            baseUrl: props.baseUrl,
            extraLink: props.extraLink,
            funcionCambiarTipoPoi: props.funcionCambiarTipoPoi
        };
        if (props.region) {
            newState.region = props.region;
        } else {
            newState.region = 'region-todas';
        }
        if (props.tipos) {
            newState.tipos = props.tipos;
        }
        this.setState(newState);
    }

    constructor(props) {
        super(props);
        this.state = {
            region: 'region-todas',
            tipos: [],
            extraLink: undefined
        };
    }

    componentWillReceiveProps(nextProps) {
        let next = JSON.stringify(nextProps.tipos);
        let current = JSON.stringify(this.props.tipos);
        if (next !== current) {
            this.update(nextProps);
        }
    }

    shouldComponentUpdate(nextProps) {
        let next = JSON.stringify(nextProps.tipos);
        let current = JSON.stringify(this.props.tipos);
        return next !== current;
    }

    doSlick() {
        $("#menu_tipo_poi2").slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<a href="#" class="tipo-poi-slick-nav-control slick-prev"><i class="fa fa-2x fa-fw fa-angle-left"></i></a>',
            nextArrow: '<a href="#" class="tipo-poi-slick-nav-control slick-next"><i class="fa fa-2x fa-fw fa-angle-right"></i></a>'
        });
    }

    componentDidMount() {
        this.update(this.props);
        this.doSlick();
    }

    componentWillUpdate() {
        $("#menu_tipo_poi2").slick("unslick");
    }

    componentDidUpdate() {
        this.doSlick();
    }

    handleClick(e) {
        $(".tipo_poi_link").removeClass("active");
        $(e.target).parent().addClass("active");
    }

    getOnClickUrl(baseUrl, resto, asQuery) {
        if (asQuery) {
            if (baseUrl.indexOf('?') !== -1) {
                return `${baseUrl}&tipo=${resto}`;
            }
            return `${baseUrl}?tipo=${resto}`;
        }
        return `${baseUrl}/${resto}`;
    }

    render() {
        let _this = this;
        return (
            <div>
                <div id="menu_tipo_poi2" key={'menu'} className={"hidden-xs " + this.state.region}>
                    {
                        (function () {
                            let code = [];
                            if (_this.state.tipos && _this.state.tipos.length > 0) {
                                _this.state.tipos.forEach(function (tipo_poi, index) {
                                    let poiSlug = tipo_poi.tipo.slug || "";
                                    let className = 'tipo_poi_link';
                                    if (poiSlug === _this.state.elegido) {
                                        className = `${className} active`;
                                    }
                                    code.push(
                                        <div key={poiSlug}>
                                            <Link onClick={(e) => _this.handleClick(e)}
                                                  to={_this.getOnClickUrl(_this.state.baseUrl, poiSlug, _this.props.inSearch)}
                                                  key={`${tipo_poi.tipo.slug}l`}
                                                  className={className}>
                                                <span>{tipo_poi.tipo.nombre}</span>
                                            </Link>
                                        </div>
                                    )
                                });
                            }
                            return code;
                        })()
                    }
                    {
                        (function () {
                            if (_this.state.extraLink) {
                                return (
                                    <div key={"extra_link"}>
                                        <Link to={`${_this.state.extraLink.url}`} className="tipo_poi_link">
                                            <span>{_this.state.extraLink.texto}</span>
                                        </Link>
                                    </div>
                                );
                            }
                        })()
                    }
                </div>
                <nav id="menu-tipo-poi"
                     className={"navbar navbar-default navbar-static-top visible-xs " + this.state.region}>
                    <form className="navbar-form navbar-left">
                        <div className="form-group">
                            <select className="form-control" onChange={this.state.funcionCambiarTipoPoi}
                                    defaultValue={this.state.elegido}>
                                <option value="">Todos</option>
                                {
                                    (this.state.tipos && this.state.tipos.length) ? (
                                            this.state.tipos.map(function (tipo_poi) {
                                                let poiSlug = tipo_poi.tipo.slug || "";
                                                return (
                                                    <option key={"menu_tipo_poi_combo_" + tipo_poi.tipo.id}
                                                            value={poiSlug}>{tipo_poi.tipo.nombre}</option>
                                                )
                                            })
                                    ) : null
                                }
                            </select>
                        </div>
                    </form>
                </nav>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MenuTipoPoi.js